"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { refreshSearchFilter } from "@packages/lib/utlils/filters/result-filters";
interface BreadcrumbData {
  label: string;
  url?: string;
  Imgurl?: string;
}

interface BreadcrumbProps {
  data: BreadcrumbData[];
  disableLast?: boolean;
}

const Breadcrumblayoutcomponent = ({
  data,
  disableLast = false,
}: BreadcrumbProps) => {
  const bcLen = data?.length ?? 1;

  const renderBreadcrumbItem = (
    breadcrumbData: BreadcrumbData,
    index: number
  ) => {
    const isLastItem = disableLast && index === bcLen - 1;
    const linkClasses =
      'text-primary-400 hover:underline after:absolute after:content-["/"] after:w-[20px] after:h-[20px] after:text-center after:text-grey-300';

    if (isLastItem || !breadcrumbData.url) {
      return <span className="text-grey300">{breadcrumbData?.label}</span>;
    }

    return (
      <Link
        className={linkClasses}
        href={breadcrumbData?.url}
        onNavigate={() => refreshSearchFilter(breadcrumbData?.url)}
      >
        {breadcrumbData?.Imgurl ? (
          <Image
            src={breadcrumbData?.Imgurl}
            width={17}
            height={18}
            className="inline-block"
            alt="breadcrumb icon"
            style={{ width: "17px", height: "18px" }}
          />
        ) : (
          breadcrumbData?.label
        )}
      </Link>
    );
  };

  return (
    <nav aria-label="breadcrumb">
      <ul className="flex flex-wrap gap-[20px]">
        {data.map((breadcrumbData, index) => (
          <li className="small" key={index + 1}>
            {renderBreadcrumbItem(breadcrumbData, index)}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumblayoutcomponent;
